import * as React from "react";
import PropTypes from "prop-types";
import NatTime from "../../../components/text/NatTime";
import ClientNames from "../../../components/links/ClientNames";
import AdminContainerMigrate from "../../../components/container/AdminContainerMigrate";
import ListKFWers from "../ListKFW/ListKFWers";
import { shiftActionPOST } from "../../../api/apiEndpoints";
import { Save } from "../../../components/icons/Icons";

export const pageOptions = {
	MakeAvailable: "Make Available",
	ShowPostAvailable: "Show Post Available"
};

export default class MakeShiftGenerallyAvailable extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			page: this.props.page || pageOptions.MakeAvailable
		};
	}

	render() {
		if (this.state.page === pageOptions.MakeAvailable) {
			return (
				<div>
					<h4 className="heading">Make Shift Available</h4>

					<p>Make this shift available?</p>
					<div>
						<b>
							<ClientNames clientIds={this.props.shift.ChildClientIds} />
						</b>
					</div>
					<div>
						<NatTime
							startTime={this.props.shift.StartTime}
							endTime={this.props.shift.EndTime}
						/>
					</div>

					<AdminContainerMigrate
						align="right"
						buttons={[
							<button
								className="btn btn-success"
								onClick={() => {
									shiftActionPOST({
										Action: "generally_available",
										ShiftId: this.props.shift.Id
									}).then(() => {
										this.setState({ page: pageOptions.ShowPostAvailable });
									});
								}}
							>
								<Save /> Make Available
							</button>
						]}
					/>
				</div>
			);
		}

		if (this.state.page === pageOptions.ShowPostAvailable) {
			return (
				<div>
					<h4 className="heading">Make Shift Available</h4>
					<div className="row">
						<div className="col-sm-12">
							After making this shift available please take a screenshot and post it
							into the relevant group chat to other skimpies who might cover it.
							Remember to state your general reason and whether you will be able to
							honour this reservation if there is no cover found, or not.
						</div>
						<div className="col-sm-12">
							<a target="_blank" href="/skimpy_bible/Covers,%20Lateness,%20No%20Shows">
								Link to Skimpy Bible Chapter - Covers, Lateness, No Shows
							</a>
						</div>
					</div>
					<AdminContainerMigrate
						align="right"
						buttons={[
							<button
								className="btn btn-primary pull-right"
								onClick={this.props.handleCloseModal}
							>
								Okay
							</button>
						]}
					/>
				</div>
			);
		}
	}
}

MakeShiftGenerallyAvailable.propTypes = {
	shift: PropTypes.object.isRequired,
	handleCloseModal: PropTypes.func.isRequired,
	page: PropTypes.string
};
